import React from 'react';
import classnames from 'classnames';

import Avatar from 'react-avatar';

import { ensureScheme, buildIPFSUrl } from 'utils/url';

const scheme = process.env.REACT_APP_FILE_STORAGE_DEFAULT_SCHEME || 'https';

export default function({ user, className, size, disableURL, ...otherProps }) {
  const url = user
    ? ensureScheme(user.imgUrl ? user.imgUrl : buildIPFSUrl(user.photoIpfs), scheme)
    : undefined;
  if (url && !disableURL) {
    return <Avatar src={url} className={className} size={size} round {...otherProps} />;
  } else {
    return (
      <Avatar
        name={user.name}
        maxInitials={3}
        className={classnames('text-light', 'text-center', className)}
        size={size}
        color="#E14B4D"
        round
        {...otherProps}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/users/avatar/index.js